import { render, staticRenderFns } from "./FolderControlPanel.vue?vue&type=template&id=132526f6&scoped=true&"
import script from "./FolderControlPanel.vue?vue&type=script&lang=js&"
export * from "./FolderControlPanel.vue?vue&type=script&lang=js&"
import style0 from "./FolderControlPanel.vue?vue&type=style&index=0&id=132526f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132526f6",
  null
  
)

export default component.exports